import { useMemo } from 'react';
import { useCampaignSettingsSelector } from './useCampaignSettingsSelector';

export const useStatusSelector = () => {
  const settings = useCampaignSettingsSelector();
  return useMemo(() => settings.status, [settings.status]);
};
